"use client";

import { useEffect, useRef } from "react";
import { useHolidayQuoteBrand } from "./contexts/use-holiday-quote-brand";

interface QuoteFooterProps {
  className?: string;
}

export function QuoteFooter({ className = "" }: QuoteFooterProps) {
  const { footerConfig } = useHolidayQuoteBrand();
  const footerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!footerConfig?.html || !footerRef.current) return;

    // Insert the HTML content
    footerRef.current.innerHTML = footerConfig.html;

    // Add CSS styles
    if (footerConfig.css) {
      const styleId = "quote-footer-styles";
      let styleElement = document.getElementById(styleId) as HTMLStyleElement;

      if (!styleElement) {
        styleElement = document.createElement("style");
        styleElement.id = styleId;
        document.head.appendChild(styleElement);
      }

      styleElement.textContent = footerConfig.css;
    }

    // Execute JavaScript
    if (footerConfig.script) {
      try {
        // Create a new function from the script content
        const scriptFunction = new Function(footerConfig.script);
        scriptFunction();
      } catch (error) {
        console.error("Error executing footer script:", error);
      }
    }
  }, [footerConfig]);

  if (!footerConfig?.html) {
    return null;
  }

  return (
    <div
      ref={footerRef}
      className={`quote-footer ${className}`}
      data-testid="quote-footer"
    />
  );
}
